export default {
  首页: "Domov",
  资产: "Sredstva",
  币币: "Spot",
  快捷买币: "Hitri nakup kriptovalut",
  "支持多种方式购买，购买更简单": "Enostavno kupujte z več načini plačila",
  语言设置: "Jezikovne nastavitve",
  确认恢复: "Potrdi obnovitev",
  "输入邮箱，方便我们联系您":
    "Vnesite svoj e-poštni naslov, da vas lahko kontaktiramo",
  划转: "Prenos",
  行情: "Trg",
  "24H成交": "Obseg 24h",
  累计收益: "Skupni donos",
  充值时间: "Datum pologa",
  到期时间: "Datum poteka",
  数量: "Količina",
  操作: "Dejanje",
  资产信息: "Podatki o sredstvih",
  复制地址: "Kopiraj naslov",
  链名称: "Ime verige",
  充值地址: "Naslov za polog",
  收款地址: "Naslov za prejem",
  账单: "Račun",
  提现金额: "Znesek za dvig",
  接收地址: "Naslov za prejem",
  交易密码: "Geslo za trgovanje",
  提现全部: "Dvigni vse",
  保存图片: "Shrani sliko",
  输入您的交易密码: "Vnesite svoje geslo za trgovanje",
  确定: "Potrdi",
  地址: "Naslov",
  注册时间: "Datum registracije",
  取消: "Prekliči",
  是否划转: "Prenos?",
  登录: "Prijava",
  我的地址: "Moji naslovi",
  登录密码和交易密码: "Geslo za prijavo in geslo za trgovanje",
  注册: "Registracija",
  密码: "Geslo",
  设置密码: "Nastavi geslo",
  重复密码: "Ponovi geslo",
  新密码: "Novo geslo",
  确认新密码: "Potrdi novo geslo",
  充值: "Polog",
  充值货币: "Polog valute",
  合约账户充值: "Polog na račun terminskih pogodb",
  账户充值: "Polog na račun",
  其他: "Drugo",
  我的邀请码: "Moja koda za povabilo",
  提现: "Dvig",
  客服: "Podpora strankam",
  持有详情: "Podrobnosti o lastništvu",
  请输入内容: "Vnesite vsebino",
  邀请好友来领取奖励: "Povabite prijatelje in prejmite nagrade",
  复制链接: "Kopiraj povezavo",
  重复设置新的密码: "Ponovi novo geslo",
  保存: "Shrani",
  我的: "Moj račun",
  "邮箱/手机号": "E-pošta/Številka mobilnega telefona",
  备注: "Opomba",
  地址管理: "Upravljanje naslovov",
  我的团队: "Moja ekipa",
  联系我们: "Kontaktirajte nas",
  竭诚为您服务: "Na voljo smo vam",
  提取收益: "Izplačilo donosa",
  带给我的收益: "Ustvarjeni donos",
  添加: "Dodaj",
  名称: "Ime",
  添加地址: "Dodaj naslov",
  修改地址: "Spremeni naslov",
  可提现: "Možnost dviga",
  安全中心: "Varnostni center",
  收益划转: "Prenos donosa",
  通知中心: "Obvestila",
  "累计收益:": "Skupni donos:",
  注册用户: "Registrirani uporabniki",
  奖励规则: "Pravila nagrajevanja",
  帮助反馈: "Pomoč in povratne informacije",
  邀请好友: "Povabi prijatelje",
  恢复身份: "Obnovitev identitete",
  选择语言: "Izbira jezika",
  设置新的密码: "Nastavi novo geslo",
  暂无活动: "Ni aktivnih dejavnosti",
  "月增长量(+)": "Mesečna rast (+)",
  可提取: "Možnost izplačila",
  反馈类型: "Vrsta povratne informacije",
  赠送: "Darilo",
  已经复制: "Kopirano",
  保存成功: "Uspešno shranjeno",
  划转成功: "Uspešen prenos",
  过期: "Poteklo",
  提交成功: "Uspešno oddano",
  "服务器繁忙，稍后在试": "Strežnik je zaseden, poskusite znova kasneje",
  全部: "Vse",
  一级: "Raven 1",
  二级: "Raven 2",
  三级: "Raven 3",
  级: "Raven",
  删除成功: "Uspešno izbrisano",
  选择地址: "Izberi naslov",
  不再提醒: "Ne prikazuj več",
  "最小充值金额：": "Najmanjši znesek pologa:",
  选择币种: "Izberi kriptovaluto",
  输入投资金额: "Vnesite znesek naložbe",
  输入账户密码: "Vnesite geslo računa",
  投资: "Naložba",
  订单编号: "Številka naročila",
  投资周期: "Obdobje naložbe",
  投资资金: "Vloženi znesek",
  投资时间: "Čas naložbe",
  状态: "Stanje",
  投资中: "Aktivno",
  已到期: "Poteklo",
  暂无数据: "Ni podatkov",
  转入: "Prenos na",
  邮箱: "E-pošta",
  请输入邮箱: "Vnesite e-poštni naslov",
  请输入格式正确的邮箱: "Vnesite veljaven e-poštni naslov",
  请输入验证码: "Vnesite kodo za preverjanje",
  获取验证码: "Pridobi kodo za preverjanje",
  请输入邀请码: "Vnesite kodo za povabilo",
  今天: "Danes",
  昨天: "Včeraj",
  最近七天: "Zadnjih 7 dni",
  邀请: "Povabilo",
  购买数量: "Količina za nakup",
  产品详情: "Podrobnosti izdelka",
  币种: "Kriptovaluta",
  利息币种: "Valuta donosa",
  理财类型: "Vrsta finančnega produkta",
  产品费率: "Stroški produkta",
  进行中: "Aktivno",
  每天: "Dnevno",
  请输入搜索关键词: "Vnesite iskalni izraz",
  通知: "Obvestila",
  查看更多: "Poglej več",
  理财宝: "Finančni produkti",
  周期: "Rok",
  年利率: "Letna obrestna mera (APY)",
  更多产品: "Več produktov",
  灵活存取: "Fleksibilno varčevanje",
  稳定收益: "Stabilen donos",
  合约指南: "Vodnik za terminske pogodbe",
  资金划转出: "Odhodni prenos",
  矿池收益: "Nagrada za rudarjenje",
  提现手续费: "Strošek dviga",
  冻结资金: "Zamrznjena sredstva",
  解冻资金: "Odmrznitev zamrznjenih sredstev",
  闪兑支出: "Strošek hitre zamenjave",
  闪兑收入: "Prihodek od hitre zamenjave",
  闪兑手续费: "Strošek hitre zamenjave",
  合约支出: "Strošek terminskih pogodb",
  合约收入: "Prihodek od terminskih pogodb",
  输入的金额不可大于可用金额:
    "Znesek ne sme biti večji od razpoložljivega zneska",
  全部兑换成功: "Uspešna popolna zamenjava",
  返回: "Nazaj",
  查看历史: "Poglej zgodovino",
  闪兑历史: "Zgodovina hitre zamenjave",
  支付: "Plačilo",
  获取: "Pridobi",
  时间: "Čas",
  手续费: "Strošek transakcije",
  折扣: "Popust",
  价格: "Cena",
  逐仓: "Izolirana marža",
  全仓: "Križna marža",
  市价委托: "Tržni nalog",
  限价委托: "Limitni nalog",
  请输入本金: "Vnesite glavnico",
  请输入价格: "Vnesite ceno",
  "可做空/做多": "Možno odpiranje Short/Long pozicije",
  设置止盈止损: "Nastavi omejitev dobička/zaustavitev izgube",
  止盈价: "Cena omejitve dobička",
  止损价: "Cena zaustavitve izgube",
  成本: "Stroškovna cena",
  做多: "Long (Nakup)",
  做空: "Short (Prodaja)",
  仓位信息: "Informacije o poziciji",
  一键平仓: "Zapri pozicijo (en klik)",
  永续: "Perpetual",
  浮动盈亏: "Nerealiziran dobiček/izguba",
  平仓: "Zapri pozicijo",
  反向开仓: "Odpri obratno pozicijo",
  一键撤销: "Prekliči vse (en klik)",
  倍杠杆: "x vzvod",
  执行价格: "Cena izvršitve",
  委托数量: "Količina naloga",
  保证金: "Marža",
  成交价: "Cena izvršitve",
  创建时间: "Čas ustvarjanja",
  撤销: "Prekliči",
  合约市场: "Trg terminskih pogodb",
  交易方向: "Smer trgovanja",
  委托价格: "Cena naloga",
  委托金额: "Znesek naloga",
  资金费率: "Stopnja financiranja",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Periodični strošek, ki ga plačujejo long in short pozicije, poravnava se vsakih 8 ur.",
  "资金费率为正，多方向空方支付资金费用。":
    "Pri pozitivni stopnji financiranja long pozicije plačujejo short pozicijam.",
  "资金费率为负，空方向多方支付资金费用。":
    "Pri negativni stopnji financiranja short pozicije plačujejo long pozicijam.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Ali ste prepričani, da želite odpreti obratno pozicijo? To bo kupilo nasprotno smer vaše trenutne pozicije.",
  "仓位止盈/止损": "Omejitev dobička/zaustavitev izgube za pozicijo",
  合约名称: "Terminska pogodba",
  开仓价格: "Cena odprtja",
  指数价格: "Cena indeksa",
  止盈设置: "Nastavitve omejitve dobička",
  请输入止盈价: "Vnesite ceno omejitve dobička",
  "当指数价格触达*时，将会触发委托平仓":
    "Ko cena indeksa doseže *, se sproži nalog za zaprtje.",
  预计盈亏: "Pričakovan dobiček/izguba",
  当前仓位: "Trenutna pozicija",
  平仓金额: "Znesek zaprtja",
  仓位模式: "Način pozicije",
  全仓模式: "Način križne marže",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "V načinu križne marže se vsa razpoložljiva sredstva na vašem računu terminskih pogodb uporabljajo kot marža. Likvidacija se zgodi, ko izguba preseže vaše skupno stanje, kar povzroči izgubo celotne marže in pozicije.",
  逐仓模式: "Način izolirane marže",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Določen znesek marže se dodeli poziciji. Če izguba marže pade pod raven vzdrževalne marže, se pozicija likvidira. Za to pozicijo lahko povečate ali zmanjšate maržo.",
  "是否撤销？": "Preklic naloga?",
  "是否一键撤销？": "Preklic vseh nalogov?",
  "是否一键平仓？": "Zapreti vse pozicije?",
  持仓保证金: "Marža trenutne pozicije",
  风险率: "Odstotek tveganja",
  未实现盈亏: "Nerealiziran dobiček/izguba",
  可用保证金: "Razpoložljiva marža",
  净值: "Neto vrednost",
  账户余额: "Stanje računa",
  合约计算器: "Kalkulator terminskih pogodb",
  交易记录: "Zgodovina transakcij",
  "*倍杠杆": "*x vzvod",
  "平仓盈亏：": "Realiziran dobiček/izguba:",
  时间筛选: "Filter časa",
  仓位类型: "Vrsta pozicije",
  订单状态: "Stanje naročila",
  订单类型: "Vrsta naloga",
  平仓价格: "Cena zaprtja",
  持仓数量: "Količina pozicije",
  "手续费(%)": "Strošek transakcije (%)",
  平仓时间: "Čas zaprtja",
  平仓类型: "Vrsta zaprtja",
  手动平仓: "Ročno zaprtje",
  强制平仓: "Prisilna likvidacija",
  近1天: "Zadnji dan",
  近7天: "Zadnjih 7 dni",
  近30天: "Zadnjih 30 dni",
  近180天: "Zadnjih 180 dni",
  持仓: "Odprta pozicija",
  已取消: "Preklicano",
  分时: "Znotrajdnevno",
  "24H额(USDT)": "Obseg 24h (USDT)",
  "24H低": "Najnižja 24h",
  "24H量(BTC)": "Obseg 24h (BTC)",
  "24H高": "Najvišja 24h",
  "10秒": "10 sekund",
  "30秒": "30 sekund",
  "1分": "1 minuta",
  "3分": "3 minute",
  "5分": "5 minut",
  "30分": "30 minut",
  "1小时": "1 ura",
  "4小时": "4 ure",
  "8小时": "8 ur",
  "1天": "1 dan",
  "1周": "1 teden",
  "1月": "1 mesec",
  单向持仓: "Enosmerna pozicija",
  杠杆: "Vzvod",
  仓位: "Pozicija",
  计算结果: "Rezultat",
  盈亏: "Dobiček/Izguba",
  收益率: "Donos",
  计算结果仅供参考: "Rezultat je informativen",
  成交后仓位大小: "Velikost pozicije po izvršitvi",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Rezultat je informativen, dejanski rezultati se lahko razlikujejo zaradi stroškov.",
  目标价格: "Ciljna cena",
  开始计算: "Izračunaj",
  强平价格: "Cena likvidacije",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Pred pologom natančno preverite ime verige. Nepravilnih pologov ni mogoče razveljaviti. Najmanjši znesek pologa je *. Pologi pod tem zneskom ne bodo obdelani. Ne pošiljajte drugih sredstev na ta naslov. Ne uporabljajte ICO ali naslovov za zbiranje sredstev za dvige.",
  "最小输入*": "Najmanj {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Najmanjša količina za dvig je *. Stroški dviga bodo odšteti od zneska dviga. Natančno preverite naslov prejemnika. Ne pošiljajte * na naslove zunaj *. Ne uporabljajte ICO ali naslovov za zbiranje sredstev.",
  退出登录: "Odjava",
  加仓: "Povečanje pozicije",
  新增仓位: "Nova pozicija",
  输入加仓金额: "Vnesite znesek za povečanje pozicije",
  "当前可用:": "Trenutno na voljo:",
  资产账单: "Račun sredstev",
  保存二维码: "Shrani QR kodo",
  温馨提示: "Opomba",
  "请注意：您当前使用的网络": "Opomba: Trenutno uporabljate omrežje",
  输入提现地址: "Vnesite naslov za dvig",
  "可用金额：": "Razpoložljivi znesek:",
  输入资产密码: "Vnesite geslo za sredstva",
  可用手续费: "Razpoložljivi strošek",
  "折扣%": "Popust %",
  实扣手续费: "Dejansko zaračunani strošek",
  实际到账: "Dejansko prejeti znesek",
  未设置资产密码: "Ni nastavljenega gesla za sredstva",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Zaradi vaše varnosti nastavite geslo za sredstva, preden izvedete dvig.",
  热榜: "Priljubljeno",
  涨幅榜: "Največje rasti",
  跌幅榜: "Največji padci",
  成交额榜: "Lestvica obsega",
  关于我们: "O nas",
  登录密码: "Geslo za prijavo",
  设置: "Nastavitve",
  资产密码: "Geslo za sredstva",
  修改登录密码: "Spremeni geslo za prijavo",
  原密码: "Staro geslo",
  请输入新密码: "Vnesite novo geslo",
  请输入原密码: "Vnesite staro geslo",
  确认密码: "Potrdi geslo",
  确定修改: "Potrdi spremembo",
  修改资产密码: "Spremeni geslo za sredstva",
  验证码: "Koda za preverjanje",
  资产密码使用提示: "Namigi za geslo sredstev",
  "资产密码用于转移、提取资产和交易。":
    "Geslo za sredstva se uporablja za prenos, dvig in trgovanje s sredstvi.",
  "创建与登录密码不同的资产密码。":
    "Ustvarite geslo za sredstva, ki se razlikuje od gesla za prijavo.",
  "定期更改您的资产密码。": "Redno spreminjajte svoje geslo za sredstva.",
  提币历史: "Zgodovina dvigov",
  "金额/余额": "Znesek/Stanje",
  "手续费/折扣": "Strošek/Popust",
  自选: "Priljubljene",
  现货: "Spot",
  市价: "Tržna cena",
  止损设置: "Nastavitve zaustavitve izgube",
  合约K线图: "Grafikon terminskih pogodb",
  "24H量": "Obseg 24h",
  "24H额": "Obseg 24h (USDT)",
  合作指南: "Vodnik za partnerje",
  盈亏计算: "Izračun dobička/izgube",
  当前可用: "Trenutno na voljo",
  请输入加仓金额: "Vnesite znesek za povečanje pozicije",
  请重新输入加仓金额: "Ponovno vnesite znesek za povečanje pozicije",
  平仓数量: "Količina za zaprtje",
  欢迎登录: "Dobrodošli nazaj",
  "忘记密码?": "Ste pozabili geslo?",
  "还没有账号？": "Še nimate računa?",
  立即注册: "Registrirajte se takoj",
  繁體中文: "Tradicionalna kitajščina",
  找回密码: "Obnovitev gesla",
  下一步: "Naprej",
  注册账户: "Registracija računa",
  "请输入邀请码(选填)": "Vnesite kodo za povabilo (izbirno)",
  谢邀豪礼: "Bonus za povabilo",
  "24小时邀请好友排名": "24-urna lestvica povabil",
  "*人": "* oseb",
  "差*人": "Manka * oseb",
  "已超过10万人，每月轻松赚钱":
    "Več kot 100.000 uporabnikov, enostavno zaslužite vsak mesec",
  最高: "Največ",
  邀请链接: "Povezava za povabilo",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Delite stroške transakcij, ki jih ustvarijo vaši prijatelji (spot, terminske pogodbe, marža, hitra zamenjava).",
  平台和您一起分享手续费: "Delite stroške transakcij s platformo",
  "*级": "* raven",
  规则: "Pravila",
  我的好友: "Moji prijatelji",
  好友详情: "Podrobnosti prijatelja",
  获得好友佣金方案: "Načrt provizije za prijatelje",
  我的等级: "Moja raven",
  我的邀请数据: "Moji podatki o povabilih",
  当前等级: "Trenutna raven",
  平台奖励您: "Nagrada platforme za vas",
  最高可获取平台奖励: "Največja nagrada platforme",
  邀请规则: "Pravila povabil",
  "邀请*级有效好友": "Povabite aktivne prijatelje ravni *",
  好友等级: "Raven prijatelja",
  人: "osebe",
  奖金派送: "Izplačilo bonusa",
  平台奖励: "Nagrada platforme",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Platforma si pridržuje pravico do končne razlage. V primeru goljufivih dejavnosti bodo nagrade odvzete in vaš račun bo zamrznjen. Izgubljenih sredstev ni mogoče povrniti.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Vaš račun mora biti aktiven, kar je opredeljeno kot polog vrednosti najmanj * USDT v kateri koli kriptovaluti.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Vaš povabljeni prijatelj mora biti aktivna nižja raven, opredeljena kot polog vrednosti najmanj * USDT.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Povabitelj in povabljeni ne smeta deliti istega IP naslova.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIP raven je določena s številom povabljenih prijateljev ravni *.",
  佣金成分: "Komponente provizije",
  收益统计: "Statistika donosa",
  昨日收益: "Včerajšnji donos",
  月收益: "Mesečni donos",
  获取收益: "Pridobi donos",
  "总收益：": "Skupni donos:",
  "*级好友": "Prijatelji ravni *",
  理财购买: "Nakup finančnega produkta",
  期限: "Rok",
  可用金额: "Razpoložljivi znesek",
  预估收益: "Ocenjeni donos",
  申购上限: "Največji nakup",
  项目剩余: "Preostanek projekta",
  "买入后预计*(SGT)开始计算收益。":
    "Donos bo začel teči približno ob *(SGT) po nakupu.",
  计息日: "Začetek obračuna obresti",
  申购日: "Datum nakupa",
  到账日: "Datum odobritve",
  到期自动续投: "Samodejno ponovno vlaganje ob poteku",
  申购: "Nakup",
  搜索理财项目: "Iskanje finančnega produkta",
  超高年化随心选: "Izberite med produkti z visokim donosom",
  "自由选择理财币种，稳定超额收益":
    "Prosto izberite svojo kriptovaluto za stabilne, nadpovprečne donose",
  理财总资产: "Skupna vložena sredstva",
  申购数量: "Količina za nakup",
  立即购买: "Kupi takoj",
  年化收益率: "Letni odstotek donosa (APY)",
  理财订单: "Naročila finančnih produktov",
  持有: "V lasti",
  申购份额: "Kupljeni delež",
  到账日期: "Datum odobritve",
  申购成功: "Uspešen nakup",
  到期: "Poteklo",
  是否选择做多: "Odpreti Long pozicijo?",
  "可用余额为0 不能操作": "Stanje je 0, dejanje ni mogoče",
  福利中心: "Center bonusov",
  奖励记录: "Zgodovina nagrad",
  我获取到的奖励: "Moje pridobljene nagrade",
  总价值: "Skupna vrednost",
  新手任务: "Naloge za nove uporabnike",
  身份认证: "Verifikacija identitete (KYC)",
  身份验证: "Verifikacija identitete",
  去验证: "Verificiraj takoj",
  审核中: "V čakanju",
  已验证: "Verificirano",
  认证失败: "Verifikacija neuspešna",
  基础认证: "Osnovna verifikacija",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Opomba: Verificiranih podatkov ni mogoče spreminjati. Vnesite točne podatke.",
  "国家/地区": "Država/Regija",
  请选择: "Izberi",
  证件类型: "Vrsta dokumenta",
  证件编码: "Številka dokumenta",
  身份证: "Osebna izkaznica",
  护照: "Potni list",
  驾驶证: "Vozniško dovoljenje",
  请输入编码: "Vnesite številko",
  名字: "Ime",
  请输入: "Vnesite",
  中间名: "Srednje ime",
  选填: "Izbirno",
  姓氏: "Priimek",
  中国: "Kitajska",
  身份上传: "Prenos dokumenta identitete",
  上传身份证: "Prenos osebne izkaznice",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Prenesite v formatu JPG/JPEG/PNG. Prepričajte se, da so slike jasne, popolne in enakomerno osvetljene. Največ *MB.",
  确定提交: "Pošlji",
  去认证: "Verificiraj",
  挑战任务: "Izzivalne naloge",
  注册认证任务: "Naloga registracije in verifikacije",
  完成注册认证即可领取: "Dokončajte registracijo in verifikacijo za prejem",
  领取奖励: "Prevzemi nagrado",
  新人豪礼: "Dobrodošli bonus",
  "参与人数：": "Število udeležencev:",
  条件: "Pogoj",
  入金量: "Znesek pologa",
  完成: "Dokončano",
  任务奖励: "Nagrada za nalogo",
  距任务更新: "Do posodobitve naloge",
  "条件：": "Pogoj:",
  活动规则: "Pravila dejavnosti",
  奖励明细: "Podrobnosti nagrade",
  已获得: "Pridobljeno",
  交易奖励: "Nagrada za trgovanje",
  Win奖励: "WIN nagrada",
  已领取: "Prevzeto",
  亏损金额超过: "Znesek izgube presega",
  单笔开仓金额超过: "Znesek posameznega naloga presega",
  交易量: "Obseg trgovanja",
  待完成: "Za dokončati",
  入金: "Polog",
  盈利金额超过: "Znesek dobička presega",
  开仓金额: "Znesek naloga",
  开仓金: "Znesek naloga",
  盈利: "Dobiček",
  亏损: "Izguba",
  领取: "Prevzemi",
  未领取: "Ni prevzeto",
  待领取: "Za prevzeti",
  再交易: "Trgujte naprej",
  即可获得: "da bi prejeli",
  领取成功: "Uspešno prevzeto",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Vse dejavnosti bodo poravnane na datum zaključka. Nagrade po tem potečejo.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Pridobljeni donos bo odobren na vaš račun za nagrade, ki ga lahko kadar koli zamenjate ali dvignete.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Kriptovaluta nagrade je odvisna od naloge.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Platforma si pridržuje pravico do končne razlage. V primeru goljufije pri nalogah bodo nagrade zadržane in vaš račun lahko zamrzne.",
  成长学院: "Akademija",
  "区块链 & 加密货币": "Blockchain & Kriptovalute",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Vaš celovit vodnik za kriptovalute. Spremljamo vas na vaši kripto poti.",
  "全仓合约定单的全部保证金。":
    "Skupna marža za naloge terminskih pogodb s križno maržo.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Stanje + (nerealiziran dobiček/izguba - stroški - obresti financiranja) = Neto vrednost / Uporabljena marža * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Nerealiziran dobiček/izguba neposredno vpliva na 'razpoložljivo maržo'. Če nerealiziran dobiček/izguba raste, razpoložljiva marža raste in obratno.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Stanje - (Uporabljena marža) + (nerealiziran dobiček/izguba - stroški - obresti financiranja)",
  "注:可继续用于开仓的保证金。":
    "Opomba: Marža, ki je na voljo za odpiranje novih pozicij.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Stanje + (nerealiziran dobiček/izguba - stroški - obresti financiranja)",
  "注:当前的资金结余。": "Opomba: Trenutno stanje.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Nanaša se na skupno stanje računa terminskih pogodb, vključno z zamrznjenimi zneski.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Opomba: Višji kot je odstotek tveganja, nižje je tveganje in obratno.",
  该功能尚未开发: "Ta funkcija je še v razvoju",
  重置密码: "Ponastavitev gesla",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Vnesite 8-20 znakov, vključno s črkami, številkami in posebnimi znaki",
  修改成功: "Uspešna sprememba",
  输入验证码: "Vnesite kodo za preverjanje",
  输入密码: "Vnesite geslo",
  详情说明: "Podrobnosti",
  已售罄: "Razprodano",
  剩余期限: "Preostali rok",
  限期: "Rok",
  闪兑货币选择: "Izbira valute za hitro zamenjavo",
  地区选择: "Izbira regije",
  "搜索国家/地区": "Iskanje države/regije",
  "身份信息已提交，将在*小时内审核完成":
    "Podatki o identiteti so bili poslani. Obdelava bo trajala do * ur.",
  "选择国家/地区": "Izberite državo/regijo",
  "止盈价格需高于*": "Cena omejitve dobička mora biti višja od *",
  "止损价格需低于*": "Cena zaustavitve izgube mora biti nižja od *",
  "止盈价格需低于*": "Cena omejitve dobička mora biti nižja od *",
  "止损价格需高于*": "Cena zaustavitve izgube mora biti višja od *",
  教程详情: "Podrobnosti vodiča",
  请输入止损价: "Vnesite ceno zaustavitve izgube",
  活期: "Fleksibilno",
  赎回后立即到账: "Takojšnje odobritev po odkupu",
  赎回: "Odkup",
  赎回理财: "Odkup finančnega produkta",
  是否赎回当前的理财订单: "Odkupiti trenutno naročilo finančnega produkta?",
  维护: "Vzdrževanje",
  "系统正在维护中……": "Sistem je v vzdrževanju...",
  合约: "Terminske pogodbe",
  闪电兑换: "Hitra zamenjava",
  流水挖矿: "Rudarjenje obsega",
  邀请豪礼: "Bonus za povabilo",
  计算器: "Kalkulator",
  最新价: "Zadnja cena",
  涨跌幅: "Sprememba (24h)",
  关注币种添加自选: "Dodaj kriptovaluto med priljubljene",
  一键添加自选: "Dodaj med priljubljene (en klik)",
  全标已读: "Označi vse kot prebrano",
  无消息: "Ni sporočil",
  "暂时还没有收到任何消息通知哦!": "Še niste prejeli nobenih obvestil!",
  没有更多数据: "Ni nadaljnjih podatkov",
  闪兑: "Hitra zamenjava",
  从: "Od",
  "可用余额：": "Razpoložljivo stanje:",
  至: "Do",
  预览兑换结果: "Predogled rezultata zamenjave",
  闪兑规则: "Pravila hitre zamenjave",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Hitra zamenjava je izpostavljena tržnim nihanjem. Dejansko prejeti znesek je merodajen.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Menjalne tečaje določajo tretje osebe. Zaradi stroškov in nihanj se tečaj lahko razlikuje od tržnega tečaja. Previdno preverite.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Platforma zaračuna približno *% stroškov na zamenjavo za kritje stroškov na borzah.",
  确认汇兑: "Potrdi zamenjavo",
  您预估得到: "Ocenjeni prejem",
  汇兑: "Zamenjava",
  汇兑比例: "Menjalni tečaj",
  刷新: "Osveži",
  兑换: "Zamenjaj",
  没有更多了: "Ni nadaljnjih podatkov",
  搜索币种: "Iskanje kriptovalute",
  可用: "Na voljo",
  我知道了: "Razumem",
  最新价格: "Zadnja cena",
  确认: "Potrdi",
  最大: "Največ",
  "风险率(%)": "Odstotek tveganja (%)",
  当前委托: "Trenutni nalogi",
  合作交易历史记录: "Zgodovina transakcij partnerja",
  重置: "Ponastavi",
  余额: "Stanje",
  现货账户: "Spot račun",
  合约账户: "Račun terminskih pogodb",
  WIN账户: "WIN račun",
  赏金账户: "Račun za nagrade",
  总资产折合: "Skupna sredstva (v USDT)",
  今日收益: "Današnji donos",
  充币: "Polog",
  提币: "Dvig",
  账户权益: "Vrednost računa",
  "数量/类别": "Količina/Kategorija",
  全部币种: "Vse kriptovalute",
  全部类型: "Vse vrste",
  账单信息: "Podatki o računu",
  理财赎回: "Odkup finančnega produkta",
  购买理财: "Nakup finančnega produkta",
  收入: "Prihodki",
  支出: "Odhodki",
  到: "na",
  资产划转: "Prenos sredstev",
  "最少*": "Najmanj *",
  "可用资产：": "Razpoložljiva sredstva:",
  确认划转: "Potrdi prenos",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Sredstva morate prenesti na ustrezen račun, da lahko trgujete. Prenosi med računi so brezplačni.",
  币种账户选择: "Izbira računa kriptovalute",
  选择账户: "Izberi račun",
  划转详情: "Podrobnosti prenosa",
  划转明细: "Specifikacije prenosa",
  收入账单: "Račun prihodkov",
  支出账单: "Račun odhodkov",
  金额: "Znesek",
  总收益: "Skupni donos",
  佣金: "Provizija",
  用户名: "Uporabniško ime",
  "已领取：": "Prevzeto:",
  "未领取：": "Ni prevzeto:",
  "请选择国家/地区": "Izberite državo/regijo",
  请上传身份信息: "Prenesite podatke o identiteti",
  请选择证件类型: "Izberite vrsto dokumenta",
  请填写证件编码: "Vnesite številko dokumenta",
  请填写名字: "Vnesite ime",
  请填写姓氏: "Vnesite priimek",
  投资金额: "Znesek naložbe",
  天: "dni",
  请输入手机号: "Vnesite številko mobilnega telefona",
  搜索: "Iskanje",
  搜索历史: "Zgodovina iskanj",
  热门推荐: "Priljubljene priporočila",
  "《Xspace Earn协议》": "Protokol Xspace Earn",
  我已了解并同意: "Razumem in se strinjam",
  协议: "Protokol",
  Xspace官方中文交流群: "Xspace uradna kitajska skupnost",
  Xspace官方英文交流群: "Xspace uradna angleška skupnost",
  预计维护至: "Predvideno vzdrževanje do",
  更多功能: "Več funkcij",
  下载APP: "Prenesi aplikacijo",
  理财: "Finančni produkt",
  推荐: "Priporočeno",
  Telegram官方中文频道: "Uradni Telegram kanal (kitajščina)",
  Telegram官方英文频道: "Uradni Telegram kanal (angleščina)",
  官方邮箱: "Uradni e-poštni naslov",
  客服邮箱: "E-poštni naslov podpore",
  上述信息最终解释权归官方所有:
    "Zgornje informacije so predmet uradne razlage platforme.",
  IOS版下载: "Prenesi za iOS",
  Android版下载: "Prenesi za Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Strošek transakcije = Strošek nakupa + Stopnja financiranja + Strošek prodaje",
  资金划转: "Prenos sredstev",
  止盈: "Omejitev dobička",
  止损: "Zaustavitev izgube",
  自动平仓: "Samodejno zaprtje",
  委托挂单: "Odprti nalog",
  买: "Kupi",
  卖: "Prodaj",
  "买入/做多": "Kupi/Long",
  "卖出/做空": "Prodaj/Short",
  详情: "Podrobnosti",
  浮动涨跌: "Nerealiziran dobiček/izguba",
  最小: "Najmanj",
  充币数量: "Količina za polog",
  请输入充币数量: "Vnesite količino za polog",
  支付截图: "Dokazilo o plačilu",
  提交: "Pošlji",
  上传驾驶证: "Prenos vozniškega dovoljenja",
  上传护照: "Prenos potnega lista",
  加载中: "Nalaganje...",
  上传成功: "Uspešen prenos",
  充值历史: "Zgodovina pologov",
  合约卖出手续费: "Strošek prodaje terminskih pogodb",
  合约买入手续费: "Strošek nakupa terminskih pogodb",
  系统加款: "Sistemsko odobritev",
  系统减款: "Sistemsko bremenitev",
  合约资金费率: "Stopnja financiranja terminskih pogodb",
  佣金分成: "Delitev provizije",
  U本位合约: "Terminske pogodbe z maržo v USDT",
  资产管理: "Upravljanje sredstev",
  APP下载: "Prenesi aplikacijo",
  全球领先的数字理财平台:
    "Vodilna svetovna platforma za digitalno upravljanje premoženja",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Trgujte takoj z Bitcoinom, Ethereumom in stotinami drugih digitalnih sredstev",
  "24H涨跌幅": "Sprememba 24h",
  查看更多行情: "Oglejte si več trgov",
  近24小时成交量: "Obseg 24h",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Ponuja na stotine spot in terminskih parov. Več kot 20 milijonov uporabnikov v več kot 200 državah. Vodilna svetovna platforma za digitalna sredstva.",
  用户国家分布: "Uporabniki po državah",
  用户数: "Število uporabnikov",
  交易对: "Trgovalni pari",
  服务支持: "Podpora",
  "随时随地，多平台终端交易": "Trgujte kjer koli z večplatformno podporo",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Združljiv z več napravami za vse potrebe trgovanja.",
  随时查看实时行情: "Oglejte si cene v realnem času kjer koli",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Enostavno kupujte in prodajajte BTC, ETH, DOGE in druga digitalna sredstva",
  获取您关注的加密货币价格变化预警:
    "Prejemajte opozorila o cenah za kriptovalute, ki jih spremljate",
  "查看比特币现货、期货、期权价格":
    "Oglejte si cene Bitcoin spota, terminskih pogodb in opcij",
  比较各交易所加密货币价格: "Primerjajte cene kriptovalut na različnih borzah",
  开启您的数字货币之旅: "Začnite svoje potovanje z digitalnimi sredstvi",
  快捷购买数字货币: "Hitro kupite kriptovalute",
  "使用多种支付方式交易数字货币，安全快捷":
    "Trgujte varno in hitro z več načini plačila",
  最优的交易费率: "Najboljši stroški transakcij",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "U压odobne stopnje, konkurenčne VIP ugodnosti in storitev vrhunske kakovosti.",
  可信赖的安全保障: "Zanesljiva varnost",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Napredni varnostni ukrepi in sklad SAFU ščitijo vaša sredstva pred tveganji.",
  交易: "Trgovanje",
  币币市场: "Spot trg",
  "24H成交量": "Obseg 24h",
  交易所: "Borza",
  "24H最高": "Najvišja 24h",
  "24H最低": "Najnižja 24h",
  永续合约: "Perpetualne terminske pogodbe",
  日涨跌: "Dnevna sprememba",
  交易深度: "Globina knjige naročil",
  "资产(合约)": "Sredstva (Terminske pogodbe)",
  历史仓位: "Zgodovina pozicij",
  兑换记录: "Zgodovina zamenjav",
  类型: "Vrsta",
  充值记录: "Zgodovina pologov",
  划转记录: "Zgodovina prenosov",
  类别: "Kategorija",
  历史账单: "Zgodovina računov",
  在线充值: "Spletni polog",
  安全设置: "Varnostne nastavitve",
  用于账户登录使用: "Uporablja se za prijavo v račun",
  用户提现时安全验证使用: "Uporablja se za varnostno preverjanje pri dvigih",
  验证: "Preveri",
  万: "milijon",
  随时随地开启交易: "Začnite trgovati kjer koli",
  "*货币交易所的所有功能尽在你的手中。": "Vse funkcije borze * v vaši roki.",
  "下载*货币交易所APP。": "Prenesite aplikacijo borze *.",
  下载自: "Prenesi z",
  内测版: "Beta različica",
  下载: "Prenesi",
  扫码下载: "Skenirajte za prenos",
  设置您的资产密码: "Nastavite svoje geslo za sredstva",
  法币: "Fiat",
  我要买: "Želim kupiti",
  我要卖: "Želim prodati",
  请输入金额: "Vnesite znesek",
  汇率: "Menjalni tečaj",
  获得: "Pridobi",
  支付通道: "Plačilni kanal",
  收款通道: "Kanal za prejem",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Pri prodaji se prepričajte, da je kanal za prejem na vaše ime.",
  当前法币暂不支持交易对可尝试前往提现:
    "Ta fiat par trenutno ni podprt. Poskusite dvig.",
  前往提现: "Pojdi na dvig",
  该法币暂无通道: "Ni na voljo kanala za to fiat valuto",
  "正在出售中，请耐心等待": "Prodaja poteka, prosimo počakajte",
  请选择支付通道: "Izberite plačilni kanal",
  请选择方式: "Izberite način",
  法币历史: "Zgodovina fiat transakcij",
  买币: "Kupi kriptovaluto",
  卖币: "Prodaj kriptovaluto",
  失败: "Neuspešno",
  已完成: "Končano",
  未付款: "Neplačano",
  待审核: "V čakanju",
  打款中: "Izplačilo poteka",
  订单详情: "Podrobnosti naročila",
  联系客服: "Kontaktirajte podporo",
  到账金额: "Prejeti znesek",
  通道: "Kanal",
  收款人: "Prejemnik",
  收款账户: "Račun prejemnika",
  "订单出售失败，请查下方失败原因":
    "Prodaja naročila neuspešna. Razlog glejte spodaj.",
  失败原因: "Razlog neuspeha",
  您还未进行付款: "Še niste izvedli plačila",
  您已成功购买: "Nakup je uspešen",
  已取消订单: "Naročilo preklicano",
  "订单正在审核中，请耐心等待": "Naročilo se obdeluje. Prosimo počakajte.",
  您已成功出售: "Prodaja je uspešna",
  "订单正在打款中，请耐心等待": "Izplačilo poteka. Prosimo počakajte.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Za plačilo morate obiskati drugo platformo. Pazite na varnost svojih podatkov.",
  当前法币暂不支持交易对可尝试前往充值:
    "Ta fiat par trenutno ni podprt. Poskusite polog.",
  前往充值: "Pojdi na polog",
  购买: "Nakup",
  订单号: "Številka naročila",
  单价: "Cena na enoto",
  到账数量: "Prejeta količina",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Obstaja neplačano naročilo. Ali želite sprožiti nov nalog za plačilo?",
  继续支付: "Nadaljuj s plačilom",
  重新下单: "Novo naročilo",
  是否确定出售: "Ali ste prepričani, da želite prodati?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Po potrditvi bo platforma dodelila kupca. Počakajte na ujemanje.",
  出售: "Prodaj",
  收款方式: "Način prejema",
  订单已生成: "Naročilo je ustvarjeno",
  取消订单: "Prekliči naročilo",
  请在: "Prosimo, v",
  内完成付款: "izvedite plačilo",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Zapustite platformo, prijavite se v svoj izbrani način plačila in nakažite znesek na naslednji račun prodajalca. Obvezno navedite referenco:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Brez reference prodajalec ne bo mogel potrditi plačila, kar lahko privede do izgube sredstev.",
  "未在规定的时间内付款，订单都将被取消。":
    "Če ne plačate v določenem času, bo naročilo preklicano.",
  姓名: "Ime in priimek",
  收款姓名: "Ime prejemnika",
  开户支行: "Podružnica banke",
  银行卡号: "Številka bančne kartice",
  "付款后，返回本平台": "Po plačilu se vrnite na to platformo",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Obvezno kliknite gumb 'Izvedel sem plačilo, obvesti prodajalca'",
  未点击卖家不会放款:
    "Prodajalec bo sprostil kriptovaluto šele, ko kliknete gumb",
  交易条款: "Pogoji transakcije",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Sredstva za nakup morajo biti zakonita in varna",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Prevara, piramidne sheme, igre na srečo ali druga nezakonita sredstva niso dovoljena",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Če bodo po transakciji sredstva zamrznjena ali sumljiva, ne bomo sprostili USDT in bomo izvedli vračilo denarja",
  "已付款，通知卖家": "Plačano, obvesti prodajalca",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Če danes prekličete skupno * naročil, bo vaša pravica do nakupa za danes preklicana. Preklic tega naročila?",
  添加收款方式: "Dodaj način prejema",
  是否删除此收款方式: "Izbrišem ta način prejema?",
  删除: "Izbriši",
  请选择法币: "Izberite fiat valuto",
  机构名称: "Ime institucije",
  请选择机构: "Izberite institucijo",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Vaš izbrani način prejema bo prikazan kupcem, ko prodajate kriptovaluto. Prepričajte se, da so podatki pravilni.",
  请选择银行: "Izberite banko",
  请输入姓名: "Vnesite ime",
  账号: "Številka računa",
  请输入账号: "Vnesite številko računa",
  收款码: "Koda za prejem",
  "银行账号/卡号": "Bančni račun/Številka kartice",
  "请输入银行账号/卡号": "Vnesite bančni račun/številko kartice",
  "开户支行（选填）": "Podružnica banke (izbirno)",
  请输入开户支行: "Vnesite podružnico banke",
  "加入*官方频道": "Pridružite se uradnemu kanalu *",
  关于: "O nas",
  条款: "Pogoji",
  成功: "Uspešno",
  等待: "Čakanje",
  作废: "Neveljavno",
  确认付款: "Potrdi plačilo",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Plačilo zaključeno? Po potrditvi bo prodajalec preveril prejem v roku * minut.",
  最大金额: "Največji znesek",
  最小金额: "Najmanjši znesek",
  付款: "Plačilo",
  法币充值: "Polog fiat valute",
  法币提现: "Dvig fiat valute",
  待支付: "Za plačati",
  已支付: "Plačano",
  商户名: "Ime prodajalca",
  当前没有添加支付方式: "Ni dodanega načina plačila",
  添加后再出售: "Dodajte ga pred prodajo",
  新人大礼包: "Paket dobrodošlice",
  注册即可领取: "Prejmite po registraciji",
  立即领取: "Prevzemi takoj",
  不再提示: "Ne prikazuj več",
  "该奖励需在APP中领取，请下载APP":
    "To nagrado lahko prevzamete samo v aplikaciji. Prenesite aplikacijo.",
  去交易: "Pojdi trgovat",
  期权交易: "Trgovanje z opcijami",
  交易额: "Znesek trgovanja",
  可用额度: "Razpoložljiva omejitev",
  交易周期: "Obdobje trgovanja",
  看涨: "Rast (Call)",
  看跌: "Padec (Put)",
  看空: "Short",
  当前持有: "Trenutna pozicija",
  胜率: "Odstotek uspešnosti",
  "盈利/亏损数": "Število transakcij z dobičkom/izgubo",
  累计实现盈亏: "Realiziran skupni dobiček/izguba",
  秒: "sekund",
  分: "minut",
  小时: "ur",
  周: "teden",
  下单时间: "Čas naročila",
  剩余时间: "Preostali čas",
  买入价: "Nakupna cena",
  结算价: "Cena poravnave",
  实现盈利: "Realiziran dobiček",
  结算时间: "Čas poravnave",
  期权: "Opcija",
  新手教程: "Vodnik za začetnike",
  我的订单: "Moja naročila",
  赔率: "Kvote",
  全部订单: "Vsa naročila",
  持有订单: "Odprta naročila",
  历史订单: "Zgodovina naročil",
  输入交易额度: "Vnesite znesek trgovanja",
  选择交易周期: "Izberite obdobje trgovanja",
  去注册: "Registracija",
  冻结: "Zamrzni",
  期权支出: "Strošek opcije",
  期权收入: "Prihodek od opcije",
  用户提现: "Dvig uporabnika",
  "是否购买？": "Kupiti to opcijo?",
  购买成功: "Uspešen nakup",
  请签名: "Prosimo, podpišite",
  提交签名: "Pošlji podpis",
  清空签名: "Počisti podpis",
  签名审核中: "Podpis je v preverjanju",
  已提交: "Oddano",
  扫一扫下载APP: "Skenirajte za prenos aplikacije",
  新手领取大礼包: "Paket dobrodošlice za nove uporabnike",
  注册实名即送彩金: "Registrirajte se in verificirajte za bonus",
  交易总额: "Skupni obseg trgovanja",
  资产不足: "Premalo sredstev",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Premalo sredstev na WIN računu. Sredstva lahko prenesete s svojega glavnega računa.",
  Win: "WIN",
  比赛: "Tekmovanje",
  未开始: "Se ni začelo",
  赛程: "Razpored",
  赛果: "Rezultat",
  已结束: "Končano",
  让球: "Handicap",
  进球数: "Goli",
  大: "Več (Over)",
  小: "Manj (Under)",
  胜负平: "1X2 (Zmaga/Neodločeno/Poraz)",
  和局: "Neodločeno",
  投注: "Stava",
  下注金额: "Znesek stave",
  下注: "Stavi",
  阵容: "Postava",
  分析: "Analiza",
  输入下注金额: "Vnesite znesek stave",
  下注成功: "Uspešno oddana stava",
  投注记录: "Zgodovina stav",
  未结算: "Ni poravnano",
  已结算: "Poravnano",
  流水: "Obseg",
  输赢: "Dobiček/Izguba",
  赛时: "Čas tekme",
  下注时间: "Čas stave",
  足彩竞猜: "Nogometne stave",
  查看详情: "Poglej podrobnosti",
  输: "Izguba",
  赢: "Dobiček",
  主: "Domači",
  客: "Gostujoči",
  主胜: "Zmaga domačih",
  客胜: "Zmaga gostov",
  平: "Neodločeno",
  已延期: "Preloženo",
  账号异常: "Nepravilnost računa",
  全场独赢: "1X2 celotna tekma",
  全场让球: "Handicap celotna tekma",
  全场大小: "Več/Manj celotna tekma",
  总进球: "Skupaj golov",
  拍摄照片要求: "Zahteve za fotografijo",
  标准拍摄: "Standardna fotografija",
  边框缺失: "Manjka rob",
  照片模糊: "Neostra fotografija",
  闪光强烈: "Premočan blisk",
  上传手持证件照: "Prenos fotografije z dokumentom v roki",
  上传证件照: "Prenos fotografije dokumenta",
  换一张: "Nova fotografija",
  出生日期: "Datum rojstva",
  请选择出生日期: "Izberite datum rojstva",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Vnesite spodnjo kodo za preverjanje, da prejmete kodo po e-pošti za registracijo.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Še imate * poskusov verifikacije. Po tej omejitvi se ne boste mogli verificirati.",
  上半场: "1. polčas",
  下半场: "2. polčas",
  独赢: "1X2",
  上半场独赢: "1. polčas 1X2",
  下半场独赢: "2. polčas 1X2",
  上半场让球: "1. polčas Handicap",
  下半场让球: "2. polčas Handicap",
  上半场大小球: "1. polčas Več/Manj",
  下半场大小球: "2. polčas Več/Manj",
  波胆: "Točen rezultat",
  上半场波胆: "1. polčas Točen rezultat",
  下半场波胆: "2. polčas Točen rezultat",
  单双: "Liho/Sodo",
  单: "Liho",
  双: "Sodo",
  上半场单双: "1. polčas Liho/Sodo",
  下半场单双: "2. polčas Liho/Sodo",
  上半场总进球: "1. polčas Skupaj golov",
  下半场总进球: "2. polčas Skupaj golov",
  中场: "Polčas",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Opomba: Za fotografijo z dokumentom v roki napišite besedilo na bel list papirja in ga fotografirajte skupaj s svojim dokumentom, kot je prikazano na primeru.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Pred kratkim je bilo kaznovanih veliko goljufivih računov. Če menite, da je bil vaš račun nepravično kaznovan, kontaktirajte podporo.",
  最小下注金额: "Najmanjša stava",
  参与活动最小下注金额: "Najmanjša stava za sodelovanje v dejavnosti",
  记住密码: "Zapomni si geslo",
  比分: "Rezultat",
  "您还未登录，请先登录": "Niste prijavljeni. Najprej se prijavite.",
  立即登录: "Prijavi se takoj",
  下注限额: "Omejitev stave",
  可赢金额: "Znesek, ki ga lahko dobite",
  闪兑详情: "Podrobnosti hitre zamenjave",
  大小球: "Več/Manj",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Zaradi nihanj menjalnega tečaja se lahko končni znesek stave razlikuje. Naročilo je merodajno.",
  开赛时间: "Čas začetka",
  足球收入: "Prihodki od nogometa",
  足球支出: "Odhodki za nogomet",
  活动详情: "Podrobnosti dejavnosti",
  为世界杯喝彩: "Podprite svetovno prvenstvo",
  我的竞猜: "Moje napovedi",
  "竞猜比赛、有机会瓜分*USDT": "Napovedujte tekme in osvojite del * USDT",
  "瓜分*USDT": "Razdelite * USDT",
  距离活动结束还有: "Do konca dejavnosti:",
  我的门票: "Moje vstopnice",
  竞猜结束时间: "Konec napovedi",
  猜比分: "Napoved rezultata",
  "福利派送中，完成任务即可获取门票":
    "Bonusi se delijo. Dokončajte naloge za zaslužek vstopnic.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Dokončajte naslednje naloge za ustrezno število vstopnic za sodelovanje v tekmovanju.",
  时: "ura",
  活动: "Dejavnost",
  竞猜记录: "Zgodovina napovedi",
  结果: "Rezultat",
  任务: "Naloga",
  去邀请: "Povabi",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Napovedujte rezultat vsake tekme in osvojite del od $*.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "Za napovedovanje je potrebna vstopnica. Vstopnice lahko zaslužite z dokončanjem nalog platforme.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "Po uspešni napovedi pošljite posnetek zaslona podpori. Ti bodo nakazali bonus na vaš račun, ki ga lahko takoj dvignete.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Goljufanje je prepovedano. Če bo odkrito, bo nagrada razveljavljena.",
  "完成任务后，点击咨询客服获得门票。":
    "Po dokončanju nalog kliknite 'Kontaktiraj podporo' za pridobitev vstopnic.",
  继续猜: "Nadaljuj z napovedovanjem",
  总单数: "Skupno število stav",
  赛事筛选: "Filtriraj po tekmovanju",
  球队筛选: "Filtriraj po ekipi",
  总金额: "Skupni znesek",
  总流水: "Skupni obseg",
  派奖金额: "Znesek dodeljenega bonusa",
  下注单数: "Število stav",
  利润: "Dobiček",
  更多福利: "Več bonusov",
  我的奖金: "Moj bonus",
  未认证: "Ni verificirano",
  总量: "Skupaj",
  或: "ali",
  模拟交易: "Demo trgovanje",
  体验账户不可操作: "Ni na voljo na demo računu",
  世界杯比分竞猜: "Napoved rezultatov SP",
  "领*USDT起": "Prejmite od * USDT",
  消息: "Sporočila",
  滚球: "Stave v živo",
  是: "Da",
  不是: "Ne",
  当前余额: "Trenutno stanje",
  KOL招募: "Rekrutacija KOL",
  本月净输赢: "Neto dobiček/izguba ta mesec",
  本月佣金: "Provizija ta mesec",
  佣金比例: "Odstotek provizije",
  活跃人数: "Aktivni uporabniki",
  新增下级: "Nove nižje ravni",
  登录人数: "Prijavljeni uporabniki",
  首存人数: "Uporabniki s prvim pologom",
  数据分析: "Analiza podatkov",
  人数: "Število oseb",
  新注册存款金额: "Znesek pologa novih registracij",
  老用户存款金额: "Znesek pologa obstoječih uporabnikov",
  首存金额: "Znesek prvega pologa",
  快捷入口: "Hiter dostop",
  成员管理: "Upravljanje članov",
  财务报表: "Finančna poročila",
  分红报表: "Poročilo o dividendi",
  订单记录: "Zgodovina naročil",
  VIP专享: "VIP ekskluzivno",
  推广工具: "Orodja za promocijo",
  计算规则: "Pravila izračuna",
  账变明细: "Podrobnosti transakcije",
  成员: "Člani",
  下级概览: "Pregled nižjih ravni",
  下级成员总计: "Skupaj nižjih ravni",
  本月新增: "Novi ta mesec",
  本月活跃会员: "Aktivni člani ta mesec",
  今日活跃会员: "Aktivni člani danes",
  本月有效活跃: "Efektivno aktivni ta mesec",
  活跃成员占比: "Odstotek aktivnih članov",
  本月活跃: "Aktivni ta mesec",
  今日活跃: "Aktivni danes",
  下级成员: "Nižje ravni",
  会员账号: "Račun člana",
  统计时间: "Čas statistike",
  筛选: "Filter",
  存款: "Polog",
  取款: "Dvig",
  总输赢: "Skupni dobiček/izguba",
  是否有效用户: "Aktivni uporabnik?",
  最近登录时间: "Zadnja prijava",
  否: "Ne",
  开始时间: "Čas začetka",
  结束时间: "Čas konca",
  提取: "Dvig",
  总盈亏: "Skupni rezultat",
  净盈亏: "Neto rezultat",
  分红: "Dividenda",
  概览: "Pregled",
  月度详细数据: "Mesečni podrobni podatki",
  未发放: "Ni dodeljeno",
  活跃用户: "Aktivni uporabniki",
  有效新增会员: "Efektivni novi člani",
  冲正后净输赢: "Neto dobiček/izguba po popravku",
  上月结余: "Stanje prejšnjega meseca",
  净输赢: "Neto dobiček/izguba",
  "系统每日新加坡时间1:00更新一次报表":
    "Poročila se posodabljajo vsak dan ob 01:00 po singapurskem času.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "V poročilih pozitivne številke pomenijo dobiček za partnerja, negativne številke pomenijo izgubo za partnerja.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Podatki o proviziji se posodabljajo dnevno, so informativni in ne predstavljajo dokončne osnove za izplačilo.",
  选择时间: "Izbor časa",
  足球: "Nogomet",
  投注金额: "Znesek stave",
  有效订单: "Veljavna naročila",
  下级账户: "Račun nižje ravni",
  待成交: "V čakanju",
  下单金额: "Znesek naročila",
  订单内容: "Vsebina naročila",
  秒数: "Sekunde",
  联赛: "Liga",
  队伍: "Ekipa",
  比赛时间: "Čas tekme",
  玩法: "Vrsta stave",
  等级规则表: "Tabela pravil ravni",
  等级: "Raven",
  活跃会员: "Aktivni člani",
  最新活跃: "Zadnja aktivnost",
  额外佣金: "Dodatna provizija",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Mesečno na podlagi standardov rasti. Lahko imate koristi samo od ene ravni.",
  渠道生成: "Generiranje kanala",
  创建: "Ustvari",
  渠道名称: "Ime kanala",
  注册人数: "Število registracij",
  浏览人数: "Število ogledov",
  构建状态: "Stanje gradnje",
  禁用: "Onemogoči",
  启用: "Omogoči",
  查看: "Poglej",
  创建渠道: "Ustvari kanal",
  创建成功: "Uspešno ustvarjeno",
  操作成功: "Uspešno dejanje",
  渠道详情: "Podrobnosti kanala",
  邀请码: "Koda za povabilo",
  访问人数: "Število obiskovalcev",
  渠道地址: "Naslov kanala",
  我的福利: "Moji bonusi",
  充值福利: "Bonus za polog",
  当前流水: "Trenutni obseg",
  如何参与: "Kako sodelovati",
  币种充值: "Polog kriptovalute",
  充值福利中领取福利: "Prevzemi bonus pri bonusu za polog",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Pravilo: Bonus za polog je prostovoljen, velja 24 ur po pologu. Po prevzemu je dvig začasno blokiran, dokler ni dosežena zahteva glede obsega.",
  失效日期: "Datum poteka",
  "暂无福利领取，充值后领取": "Ni na voljo bonusa. Prevzemite po pologu.",
  参与: "Sodeluj",
  充值赠送: "Bonus za polog",
  "领取*%的赠送": "Prevzemite *% bonusa",
  去领取: "Prevzemi",
  VIP奖励: "VIP nagrada",
  "当前可领取*USDT，是否确认领取": "* USDT na voljo za prevzem. Potrdite?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Po prevzemu je dvig začasno blokiran, dokler ni dosežen obseg * USDT.",
  充值送大礼: "Darilo za polog",
  "存入越多，送越多！": "Več kot položite, večje je darilo!",
  无效: "Neveljavno",
  有效: "Veljavno",
  总存金额: "Skupni položeni znesek",
  提示: "Opomba",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Pozitivne številke v skupnem in neto dobičku/izgubi pomenijo dobiček platforme. Dnevni podatki so informativni.",
  "净盈亏：总盈亏-用户返水":
    "Neto rezultat: Skupni rezultat - Vračilo uporabniku",
  盈利方: "Stran z dobičkom",
  代理: "Agent",
  客户: "Stranka",
  平局: "Neodločeno",
  平台: "Platforma",
  "已提交审核，请耐心等待": "Oddano v preverjanje. Prosimo počakajte.",
  充值日期: "Datum pologa",
  平台本月总输赢: "Skupni dobiček/izguba platforme ta mesec",
  KOL招募合作: "Sodelovanje pri rekrutaciji KOL",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Platforma odpira rekrutacijo KOL. Z računom družbenih medijev lahko uživate v dividendi in doživljenjskem zaslužku z enkratno promocijo strank.",
  级别: "Raven",
  平台利润返佣: "Provizija od dobička platforme",
  佣金案例: "Primer provizije",
  交易项目: "Produkti za trgovanje",
  "期权交易、合约交易、足球游戏":
    "Trgovanje z opcijami, trgovanje s terminskimi pogodbami, nogometne igre",
  报名方式: "Način prijave",
  点击KOL招募报名: "Kliknite za prijavo na rekrutacijo KOL",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Dobrodošli v naši ekipi. Podpiramo vas pri gradnji lastnega uporabniškega sistema. Zaslužite do *% provizije. Veselimo se vaše udeležbe.",
  输入联系方式: "Vnesite kontaktne podatke",
  最低活跃人数: "Najmanjše število aktivnih uporabnikov",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Npr.: Če aktivni uporabniki ta mesec ≥ * in skupni dobiček/izguba platforme ≥ * USDT, spadate v raven * in prejmete *% provizije.",
  比分竞猜: "Napoved rezultata",
  豪礼相赠: "Veliko darilo",
  足球活动: "Nogometna dejavnost",
  圣诞节活动: "Božična dejavnost",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Sodelovali ste v dejavnosti. Dvig je začasno blokiran. Potrebujete še * USDT obsega za odblokiranje.",
  剩余流水: "Preostali obseg",
  助力足球: "Podpora nogometu",
  佣金累计: "Skupna provizija",
  有效投注: "Veljavne stave",
  今日: "Danes",
  今日返水: "Vračilo danes",
  VIP返水: "VIP vračilo",
  返水记录: "Zgodovina vračil",
  成员信息: "Podatki o članu",
  基本信息: "Osnovni podatki",
  钱包余额: "Stanje denarnice",
  投注信息: "Podatki o stavi",
  返水: "Vračilo",
  总下注: "Skupna stava",
  今日输赢: "Dobiček/Izguba danes",
  下注动态: "Aktivnost stav",
  返水奖励: "Nagrada za vračilo",
  分红金额: "Znesek dividende",
  返水支出: "Strošek vračila",
  总返水: "Skupno vračilo",
  流水总额: "Skupni obseg",
  返水总额: "Skupno vračilo",
  返水详情: "Podrobnosti vračila",
  日流水: "Dnevni obseg",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Platforma daje dodatno vračilo na podlagi dnevnega obsega vaših nižjih ravni. Izplačilo vsak dan ob 00:00 po singapurskem času na račun za nagrade.",
  "申请成功，等待审核": "Zahteva uspešna, čakanje na preverjanje",
  "我出本金，盈利共分享": "Jaz dam kapital, dobiček se deli",
  最高分红: "Največja dividenda",
  投资大师比赛: "Tekmovanje Mojster investitor",
  "我出本金，你盈利": "Jaz dam kapital, ti zaslužiš",
  共分享: "Skupno deljenje",
  最高分红可得: "Največja možna dividenda",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Ekskluzivni bonus dobrodošlice: $* brezplačno. Po prevzemu lahko vlagate v kateri koli projekt. Dobiček je takoj dvigljiv.",
  报名领取: "Prijavi se in prevzemi",
  审核驳回: "Preverjanje zavrnjeno",
  驳回原因: "Razlog zavrnitve",
  活动运行周期: "Obdobje dejavnosti",
  "申请成功后起至*天内完成超额收益。":
    "Dosežite presežni donos v * dneh po odobritvi.",
  分红比: "Razmerje dividende",
  "*日获得盈利后，可获得*%的收益额。":
    "Po doseženem dobičku na dan * prejmete *% zneska donosa.",
  参与条件: "Pogoji sodelovanja",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Uporabniki iz Rusije ali Turčije, ki še niso sodelovali.",
  计算项目: "Izračunani produkti",
  "合约、体育、期权": "Terminske pogodbe, Šport, Opcije",
  我的投资: "Moje naložbe",
  参与天数: "Dnevi sodelovanja",
  累计下注: "Skupna stava",
  累计盈亏: "Skupni dobiček/izguba",
  预计可分红: "Pričakovana dividenda",
  常见问题: "Pogosta vprašanja (FAQ)",
  什么是平台出资: "Kaj je financiranje platforme?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Platforma daje brezplačna sredstva uporabnikom iz določenih držav za vlaganje v projekte.",
  怎么获取平台出资的福利: "Kako pridobiti bonus financiranja platforme?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Če ste iz ene od določenih držav, kliknite gumb za prijavo. Po odobritvi bo * USDT preneseno na vaš račun za nagrade, ki ga lahko prenesete za vlaganje.",
  什么是分红: "Kaj je dividenda?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Dividenda: Če v določenem času donos doseže 100%, prejmete 50% presežnega donosa. Npr.: Prejmete 100 USDT, dosežete 120% donosa, potem je 20% presežek.",
  "如何取得分红？": "Kako dobiti dividendo?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Cikel dejavnosti je vsakih * dni. Po zaključku se izvede obračun. Če izpolnjujete zahteve, se dividenda pošlje na račun za nagrade. Če ne izpolnjujete, bodo vaš donos in financiranje platforme odstranjeni.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Računi, ki sodelujejo, morajo biti verificirani s KYC. Samo en bonus na račun.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC za sodelovanje velja samo za določene države. Preverite, ali vaša država ustreza državi dejavnosti.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Po uspešnem sodelovanju je dvig začasno blokiran do zaključka dejavnosti.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Upoštevajte pravila dejavnosti. V primeru goljufije ali zlorabe sistemskih napak bodo vsa sredstva na vašem računu trajno zamrznjena.",
  平台出资: "Financiranje platforme",
  平台出资收回: "Preklicano financiranje platforme",
  投资大师奖励: "Nagrada Mojster investitor",
  请下载APP添加收款方式: "Prenesite aplikacijo za dodajanje načina prejema",
  请下载APP进行身份验证: "Prenesite aplikacijo za verifikacijo identitete",
  请下载APP参与: "Prenesite aplikacijo za sodelovanje",
  技术指标: "Tehnični indikatorji",
  主图: "Glavni grafikon",
  副图: "Pomožni grafikon",
  新注册人数: "Nove registracije",
  老用户存款人数: "Obstoječi uporabniki, ki polagajo",
  存款人数: "Število pologov",
  取款人数: "Število dvigov",
  投注人数: "Število stav",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Izključujoč uporabnike iz Indonezije, Indije, Bangladeša, ki še niso sodelovali.",
  市场动态: "Dinamika trga",
  外汇合约: "Forex terminske pogodbe",
  盈亏比: "Razmerje dobička/izgube",
  委托价: "Cena naloga",
  可用余额: "Razpoložljivo stanje",
  持仓额: "Vrednost pozicije",
  强平价: "Cena likvidacije",
  修改: "Spremeni",
  修改价位: "Spremeni ceno",
  外汇: "Forex",
  外汇账户: "Forex račun",
  我的交易: "Moje transakcije",
  未设置: "Ni nastavljeno",
  超出最大可设数值: "Presega največjo nastavljivo vrednost",
  超出最小可设数值: "Pod najmanjšo nastavljivo vrednostjo",
  止盈超出最小可设数值: "Omejitev dobička pod najmanjšo nastavljivo vrednostjo",
  止损超出最大可设数值:
    "Zaustavitev izgube presega največjo nastavljivo vrednost",
  止盈超出最大可设数值:
    "Omejitev dobička presega največjo nastavljivo vrednost",
  止损超出最小可设数值:
    "Zaustavitev izgube pod najmanjšo nastavljivo vrednostjo",
  挖矿: "Rudarjenje",
  交易账户: "Trgovalni račun",
  买涨: "Kupi (Long)",
  买跌: "Prodaj (Short)",
  请输入正确的银行卡信息: "Vnesite pravilne podatke bančne kartice",
  联系在线客服: "Kontaktirajte podporo v živo",
  法币交易请联系在线客服: "Kontaktirajte podporo za fiat trgovanje",
  提交订单: "Pošlji naročilo",
  "支付过程如有疑问,请联系在线客服":
    "Kontaktirajte podporo za vprašanja o postopku plačila",
  彩金赠送: "Dodelitev bonusa",
  在线客服: "Podpora v živo",
  最少投资: "Najmanjša naložba",
  "提交时间:": "Čas oddaje:",
  提现拒绝: "Dvig zavrnjen",
  认证拒绝: "Verifikacija zavrnjena",
  认证通过: "Verifikacija sprejeta",
  请输入正确的交易额度: "Vnesite veljaven znesek trgovanja",
  最大下注金额: "Največja stava",
  手机号: "Številka mobilnega telefona",
  邮箱注册: "Registracija z e-pošto",
  手机号注册: "Registracija z mobilnim telefonom",
  查询: "Poizvedba",
  手机号登录: "Prijava z mobilnim telefonom",
  邮箱登录: "Prijava z e-pošto",
  请输入数量: "Vnesite količino",
  可用数量: "Razpoložljiva količina",
  钱包登录: "Prijava z denarnico",
  请输入正确的邀请码: "Vnesite veljavno kodo za povabilo",
  "请输入邀请码(必填)": "Vnesite kodo za povabilo (obvezno)",
  输入正确的金额: "Vnesite veljaven znesek",
  法币充值: "Polog fiat valute",
  卢比充值: "Polog indijske rupije",
  请输入法币: "Vnesite fiat znesek",
  请输入IFSC: "Vnesite IFSC kodo",
  "银行编码(选填)": "Bancna koda (izbirno)",
  请输入银行编码: "Vnesite bančno kodo",
  请输入大于8位数的密码: "Vnesite geslo z več kot 8 znaki",
  添加成功: "Uspešno dodano",
  "60秒": "60 sekund",
  "180秒": "180 sekund",
  "300秒": "300 sekund",
  "2次密码不一致": "Gesli se ne ujemata",
  输入提币数量: "Vnesite količino za dvig",
  图片格式不正确: "Neveljavna oblika slike",
  图片大于20M: "Slika je večja od 20 MB",
  请设置委托价格: "Nastavite ceno naloga",
  输入资金密码: "Vnesite geslo za sredstva",
  验证码错误: "Nepravilna koda za preverjanje",
  充值拒绝: "Polog zavrnjen",
  请输入SSN: "Vnesite SSN",
  结算完成: "Poravnava končana",
  继续下单: "Nadaljuj z naročilom",
  限价: "Limitni nalog",
  买入价格: "Nakupna cena",
  买入量: "Količina za nakup",
  卖出价格: "Prodajna cena",
  卖出量: "Količina za prodajo",
  买入: "Kupi",
  卖出: "Prodaj",
  订单创建成功: "Naročilo uspešno ustvarjeno",
  币币买入支出: "Strošek spot nakupa",
  币币买入支出退还: "Povračilo stroška spot nakupa",
  币币买入获得: "Prejem od spot nakupa",
  币币卖出支出: "Strošek spot prodaje",
  币币卖出支出退还: "Povračilo stroška spot prodaje",
  币币卖出获得: "Prejem od spot prodaje",
  币币交易手续费: "Strošek spot transakcije",
  请输入限价: "Vnesite omejitveno ceno",
  成交: "Izvršeno",
  等待成交: "Čakanje na izvršitev",
  交易完成: "Transakcija končana",
  被取消: "Preklicano",
  交易时间: "Čas transakcije",
  法币交易: "Fiat transakcija",
  法币出售: "Fiat prodaja",

  两次密码不一致: "Gesli se ne ujemata",
  再次输入账户密码: "Ponovno vnesite geslo računa",

  美国: "Združene države Amerike",
  韩国: "Južna Koreja",
  阿尔巴尼亚: "Albanija",
  津巴布韦: "Zimbabve",
  赞比亚: "Zambija",
  也门: "Jemen",
  美属维尔京群岛: "Ameriški Deviški otoki",
  英属处女群岛: "Britanski Deviški otoki",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Uzbekistan",
  乌拉圭: "Urugvaj",
  英国: "Združeno kraljestvo",
  阿拉伯联合酋长国: "Združeni arabski emirati",
  乌克兰: "Ukrajina",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Otoki Turks in Caicos",
  土库曼斯坦: "Turkmenistan",
  土耳其: "Turčija",
  突尼斯: "Tunizija",
  特立尼达和多巴哥: "Trinidad in Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Vzhodni Timor",
  泰国: "Tajska",
  坦桑尼亚: "Tanzanija",
  塔吉克斯坦: "Tadžikistan",
  中国台湾: "Tajvan",
  叙利亚: "Sirija",
  瑞士: "Švica",
  瑞典: "Švedska",
  斯威士兰: "Esvatini",
  苏里南: "Surinam",
  苏丹: "Sudan",
  斯里兰卡: "Šrilanka",
  西班牙: "Španija",
  南非: "Južna Afrika",
  索马里: "Somalija",
  所罗门群岛: "Salomonovi otoki",
  斯洛文尼亚: "Slovenija",
  斯洛伐克: "Slovaška",
  "圣马丁岛（荷兰部分）": "Sveti Martin (nizozemski del)",
  新加坡: "Singapur",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Sejšeli",
  塞尔维亚: "Srbija",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Saudova Arabija",
  圣多美和普林西比: "Sveti Tomaž in Princ",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "Sveti Krištof in Nevis",
  圣文森特和格林纳丁斯: "Sveti Vincencij in Grenadine",
  圣彼埃尔和密克隆岛: "Saint Pierre in Miquelon",
  圣露西亚: "Sveta Lucija",
  圣基茨和尼维斯: "Sveti Krištof in Nevis",
  卢旺达: "Ruanda",
  俄罗斯: "Rusija",
  罗马尼亚: "Romunija",
  留尼汪: "Reunion",
  刚果共和国: "Republika Kongo",
  卡塔尔: "Katar",
  波多黎各: "Portoriko",
  葡萄牙: "Portugalska",
  波兰: "Poljska",
  菲律宾: "Filipini",
  秘鲁: "Peru",
  巴拉圭: "Paragvaj",
  巴布亚新几内亚: "Papua Nova Gvineja",
  巴拿马: "Panama",
  巴勒斯坦: "Palestina",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Norveška",
  尼日利亚: "Nigerija",
  尼日尔: "Niger",
  尼加拉瓜: "Nikaragva",
  新西兰: "Nova Zelandija",
  新喀里多尼亚: "Nova Kaledonija",
  荷属安德列斯群岛: "Nizozemski Antili",
  荷兰: "Nizozemska",
  尼泊尔: "Nepal",
  纳米比亚: "Namibija",
  缅甸: "Mjanmar",
  莫桑比克: "Mozambik",
  摩洛哥: "Maroko",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Črna gora",
  蒙古: "Mongolija",
  摩纳哥: "Monako",
  摩尔多瓦: "Moldavija",
  墨西哥: "Mehika",
  马约特: "Mayotte",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Mavretanija",
  马里亚纳群岛: "Marianski otoki",
  马提尼克: "Martinik",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Maldivi",
  马来西亚: "Malezija",
  马拉维: "Malavi",
  马达加斯加: "Madagaskar",
  马其顿: "Severna Makedonija",
  中国澳门: "Macau",
  卢森堡: "Luksemburg",
  立陶宛: "Litva",
  列支敦士登: "Lihtenštajn",
  利比亚: "Libija",
  利比里亚: "Liberija",
  莱索托: "Lesoto",
  黎巴嫩: "Libanon",
  拉脱维亚: "Latvija",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kirgizistan",
  科威特: "Kuvajt",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenija",
  哈萨克斯坦: "Kazahstan",
  约旦: "Jordanija",
  日本: "Japonska",
  牙买加: "Jamajka",
  象牙海岸: "Slonokoščena obala",
  意大利: "Italija",
  以色列: "Izrael",
  爱尔兰: "Irska",
  伊拉克: "Irak",
  伊朗: "Iran",
  印度尼西亚: "Indonezija",
  印度: "Indija",
  冰岛: "Islandija",
  匈牙利: "Madžarska",
  中国香港: "Hongkong",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Gvajana",
  几内亚比绍共和国: "Gvineja Bissau",
  几内亚: "Gvineja",
  危地马拉: "Gvatemala",
  关岛: "Guam",
  瓜德罗普岛: "Gvadelup",
  格林纳达: "Grenada",
  格陵兰岛: "Grenlandija",
  希腊: "Grčija",
  直布罗陀: "Gibraltar",
  加纳: "Gana",
  德国: "Nemčija",
  格鲁吉亚: "Gruzija",
  冈比亚: "Gambija",
  加蓬: "Gabon",
  法属波利尼西亚: "Francoska Polinezija",
  法属圭亚那: "Francoska Gvajana",
  法国: "Francija",
  芬兰: "Finska",
  斐济: "Fidži",
  法罗群岛: "Ferski otoki",
  埃塞俄比亚: "Etiopija",
  爱沙尼亚: "Estonija",
  厄立特里亚: "Eritreja",
  赤道几内亚: "Ekvatorialna Gvineja",
  萨尔瓦多: "Salvador",
  埃及: "Egipt",
  厄瓜多尔: "Ekvador",
  多米尼加共和国: "Dominikanska republika",
  多米尼加: "Dominika",
  吉布提: "Džibuti",
  丹麦: "Danska",
  捷克: "Češka",
  塞浦路斯: "Ciper",
  库拉索: "Curaçao",
  古巴: "Kuba",
  克罗地亚: "Hrvaška",
  哥斯达黎加: "Kostarika",
  科特迪瓦: "Slonokoščena obala",
  库克群岛: "Cookovi otoki",
  科摩罗: "Komori",
  哥伦比亚: "Kolumbija",
  智利: "Čile",
  乍得: "Čad",
  中非共和国: "Srednjeafriška republika",
  佛得角: "Zelenortski otoki",
  开曼群岛: "Kajmanski otoki",
  开普: "Cape",
  加拿大: "Kanada",
  喀麦隆: "Kamerun",
  柬埔寨: "Kambodža",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bolgarija",
  文莱: "Brunej",
  巴西: "Brazilija",
  博茨瓦纳: "Bocvana",
  波斯尼亚和黑塞哥维那: "Bosna in Hercegovina",
  玻利维亚: "Bolivija",
  不丹: "Butan",
  百慕大群岛: "Bermudi",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belgija",
  白俄罗斯: "Belorusija",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladeš",
  巴林: "Bahrajn",
  巴哈马: "Bahami",
  阿塞拜疆: "Azerbajdžan",
  奥地利: "Avstrija",
  澳大利亚: "Avstralija",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenija",
  阿根廷: "Argentina",
  安提瓜和巴布达: "Antigva in Barbuda",
  安圭拉: "Angvila",
  安哥拉: "Angola",
  安道尔: "Andora",
  美属萨摩亚: "Ameriška Samoa",
  阿尔及利亚: "Alžirija",
  中国: "Kitajska",
  余额不足: "Nezadostno stanje",
  最低购买: "Najmanjši nakup",
  最高购买: "Največji nakup",
  下单成功: "Naročilo uspešno oddano",
  平仓成功: "Pozicija uspešno zaprta",
  请输入正确的平仓数量: "Vnesite veljavno količino za zaprtje",
  加仓成功: "Uspešno povečanje pozicije",
  请输入正确的加仓金额: "Vnesite veljaven znesek za povečanje pozicije",
  收藏成功: "Dodano med priljubljene",
  取消收藏成功: "Odstranjeno iz priljubljenih",
  加密币永续: "Perpetual kriptovalute",
  外汇永续: "Perpetual Forex",
  期权账户: "Račun opcij",
  快捷卖币: "Hitra prodaja kriptovalute",

  托管资金: "Sredstva v upravljanju",
  托管中: "V upravljanju",
  预计日收益: "Ocenjeni dnevni donos",
  累计收益: "Skupni donos",
  周期: "Rok",
  日收益: "Dnevni donos",
  限额: "Omejitev",
  立即托管: "Začni upravljanje takoj",
  "已鎖定 請聯繫客服": "Zaklenjeno. Kontaktirajte podporo.",
  产品列表: "Seznam produktov",
  规则: "Pravila",
  创建订单: "Ustvari naročilo",
  产品名称: "Ime produkta",
  托管周期: "Obdobje upravljanja",
  等级限制: "Omejitev ravni",
  托管金额: "Znesek v upravljanju",
  限额: "Omejitev",
  余额: "Stanje",
  购买日: "Datum nakupa",
  起息日: "Začetek obračuna obresti",
  派息时间: "Čas izplačila obresti",
  每天: "Dnevno",
  计息结束日: "Datum konca obresti",
  每日收益: "Dnevni donos",
  预计收益: "Ocenjeni donos",
  "收益将自动发送至您的余额账户;":
    "Donos bo samodejno poslan na stanje vašega računa;",
  "您的资金没有任何风险;":
    "Vaša sredstva niso izpostavljena nobenemu tveganju;",
  "365*24小时不断地工作;": "Delo 24/7, 365 dni na leto;",
  托管中: "V upravljanju",
  结束: "Končano",
  今日收益: "Današnji donos",
  剩余周期: "Preostali rok",
  进行中: "Aktivno",
  已发放: "Izplačano",
  信誉分: "Točke ugleda",

  复制成功: "Uspešno kopirano",
  VIP权益: "VIP ugodnosti",
  旧密码: "Staro geslo",
  请输入旧密码: "Vnesite staro geslo",
  "忘记旧密码请联系客服重置。":
    "Če ste pozabili staro geslo, se obrnite na podporo strankam, da ga ponastavite.",
  去升级: "Nadgradi",
  描述: "Opis",
  实际存款金额: "Dejanski znesek depozita",
  升级礼金: "Bonus za nadgradnjo",
  隔夜利息: "Nočne obresti (swap)",
  自动结算: "Samodejna poravnava",
  等级规则: "Pravila ravni",
  "WEB3.0币持有数据收益": "Donos podatkov o posedovanju kovancev WEB3.0",
  总生产: "Skupna proizvodnja",
  有效节点: "Aktivna vozlišča",
  参与人: "Udeleženci",
  用户收益: "Uporabniški donos",
  "流动性WEB3.0输出": "Izhod likvidnosti WEB3.0",
  总资产: "Skupna sredstva",

  ETHAI持有数据收益: "Donos podatkov o posedovanju ETHAI",
  AI量化流动性: "AI kvantitativna likvidnost",
  现货买入手续费: "Provizija za nakup spot",
  现货支出: "Spot izdatek",
  现货资金费率: "Spot stopnja financiranja",
  现货卖出手续费: "Provizija za prodajo spot",
  现货收入: "Spot prihodek",
  外汇合约支出: "Izdatek za devizno pogodbo",
  外汇合约买入手续费: "Provizija za nakup devizne pogodbe",
  外汇合约资金费率: "Stopnja financiranja devizne pogodbe",
  外汇合约卖出手续费: "Provizija za prodajo devizne pogodbe",
  外汇合约收入: "Prihodek od devizne pogodbe",
  理财购买: "Nakup investicijskega produkta",
  VIP理财日收益: "Dnevni donos VIP investicijskega produkta",
  VIP理财隔夜利息: "Nočna obrestna mera VIP investicijskega produkta",
  VIP本金返还: "VIP vračilo glavnice",
  VIP彩金发放: "VIP izplačilo bonusa",
  VIP彩金抵扣: "VIP odbitek bonusa",
  隔夜利息: "Nočna obrestna mera",
  设置资产密码: "Nastavi geslo za sredstva",

  锁仓挖矿: "Zaklenjeno rudarjenje",
  一站式理财服务: "Finančne storitve na enem mestu",
  产品: "Izdelki",
  客服中心: "Center za podporo strankam",
  贷款: "Posojila",
  挖矿赚不停: "Neprekinjen zaslužek z rudarjenjem",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Zaklenjeno rudarjenje pomeni, da se USDT (USD:1USDT=1USD) zaupa visoko zmogljivim rudarskim napravam platforme za ustvarjanje donosov v rudarskem bazenu platforme.",
  产品优势: "Prednosti izdelka",
  随存随取: "Vplačilo in dvig kadar koli",
  锁仓周期: "Obdobje zaklepa",
  每日下发: "Dnevno izplačilo",
  随机空投: "Naključni airdrop",
  "100%资金安全保障": "100% varnost sredstev",
  "100%节假日收益不间断": "100% neprekinjen donos tudi med prazniki",
  成功锁仓后当天产出: "Donos se začne isti dan po uspešnem zaklepu",
  关于违约金: "O pogodbeni kazni",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Če želite dvigniti kapital pred zapadlostjo, se zaračuna kazen. Kazen = stopnja kazni × preostali dnevi × zaklenjen znesek.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Primer: stopnja kazni je 5 %, preostali so 3 dnevi, zaklenjen znesek je 10000U (USDT/USD). Kazen = 5%×3×10000=1500U, dejansko vrnjen kapital je 15000U-1500U.",
  收益计算: "Izračun donosa",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Platforma ponuja več finančnih produktov zaklenjenega rudarjenja. Izračun donosa je naslednji, na primer:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Če uporabnik zaklene 10000U (USDT, USD) in izbere 7-dnevni produkt z dnevnim donosom 0,7%~1,8% od zaklenjenega zneska, je dnevni donos naslednji:",
  "最低:10000Ux0.7%=70U;": "Minimum: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Maksimum: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Po 7 dneh je mogoče doseči donos 490U~1260U. Donos se izplačuje dnevno, glavnica pa se ob zapadlosti samodejno prenese na vaš račun.",
  正在托管的资金: "Sredstva v upravljanju",
  签到: "Prijava",
  锁仓订单: "Zaklenjena naročila",
  预计今日收益: "Ocenjeni današnji donos",
  累计收益: "Skupni donos",
  托管中的订单: "Naročila v upravljanju",
  单笔最少: "Minimalni znesek na naročilo",
  单笔最多: "Maksimalni znesek na naročilo",
  日收益率: "Dnevni donos",
  说明: "Opis",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Statistika temelji na GMT+8 času<br>2. Dnevni donos se izračuna na podlagi vseh poravnanih naročil med 00:00–23:59 GMT+8<br>3. Donos se izplača naslednji dan med 00:00–00:10 GMT+8.",
  知道了: "Razumem",
  锁仓: "Zakleni",
  派息时间: "Čas izplačila",
  每日: "Dnevno",
  托管资金: "Sredstva v upravljanju",
  到期返回: "Vračilo ob zapadlosti",
  提前赎回: "Predčasni dvig",
  预计收益: "Ocenjeni donos",
  认购: "Naročilo",
  热门: "Priljubljeno",
  数字货币: "Kriptovalute",
  贵金属: "Plemenite kovine",
  大宗商品: "Blago",
  持仓明细: "Podrobnosti pozicije",
  历史明细: "Zgodovina",
  当前价: "Trenutna cena",
  "↑买涨": "↑ Nakup rasti",
  "↓买跌": "↓ Nakup padca",
  显示全部: "Prikaži vse",
  买入金额: "Znesek nakupa",
  方向: "Smer",
  收益: "Dobiček",
  预期收益: "Pričakovani dobiček",
  估用保证金: "Ocenjena marža",
  确认下单: "Potrdi naročilo",
  锁定: "Zaklenjeno",
  账户总资产: "Skupna sredstva računa",
  明细: "Podrobnosti",
  今日收益: "Današnji dobiček",
  仓位保证金: "Marža pozicije",
  持有仓位: "Odprte pozicije",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Zaklenjen znesek = vsota vseh nedokončanih naročil zaklenjenega rudarjenja",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Statistika temelji na GMT+8<br>2. Dnevni donos temelji na poravnanih naročilih",
  充值方式: "Način vplačila",
  银行汇款: "Bančno nakazilo",
  "银行汇款请联系客服进行操作!": "Za bančno nakazilo se obrnite na podporo!",
  提款方式: "Način dviga",
  "银行提款请联系客服进行操作!": "Za bančni dvig se obrnite na podporo!",
  资金明细: "Podrobnosti sredstev",
  提现记录: "Zgodovina dvigov",
  拒绝: "Zavrnjeno",
  通过: "Odobreno",
  拒绝原因: "Razlog zavrnitve",

  消息公告: "Obvestila",
  订单: "Naročila",
  个人中心: "Osebni center",
  "未到期赎回需支付一定的违约金!":
    "Pri predčasnem odkupu je treba plačati pogodbeno kazen.",

  请输入区号: "Prosimo, vnesite območno kodo",
  "请选择国家/地区": "Prosimo, izberite državo/regijo",

  今日开盘: "Današnje odprtje",
  昨日收盘: "Včerajšnje zaprtje",

  实名认证即送: "Prejmite takoj po preverjanju identitete",
  立即认证: "Preveri zdaj",
  新用户礼包: "Darilni paket za nove uporabnike",
  完成新人任务领取: "Dokončajte naloge za nove uporabnike in prevzemite",
  认证: "Preveri",
  时间周期: "Časovno obdobje",
  支付金额: "Znesek plačila",
  已平仓: "Zaprto",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX pozdravni paket za nove uporabnike: vsak uporabnik lahko prejme največ",
  我已经阅读并同意: "Prebral/a sem in se strinjam z",
  隐私政策: "Politika zasebnosti",

  放弃奖励离开: "Opusti nagrado in zapusti",
  继续注册: "Nadaljuj registracijo",
  分钟: "Minute",

  "请先勾选隐私政策!": "Najprej preverite Politiko zasebnosti!",
  添加其他到自选: "Dodaj druge na seznam za spremljanje",

  充值最高可得: "Opravite dodatno vplačilo in pridobite do 30.000 $.",

  请输入格式正确的手机号:
    "Prosimo, vnesite veljavno številko mobilnega telefona.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};

// 斯洛文尼亚



// WEBPACK FOOTER //
// ./src/lang/slwny.js